import React from 'react';
import Logo from '../../../assets/images/quick-turn/quickturn-logo-3.svg';
import Parts from '../../../assets/images/quick-turn/quickturn-parts.png';
import { Button } from 'antd';
import UTMQueryPreservingLink from '../../../common/UTMQueryPreservingLink';

const Banner = () => {
    return (
        <>
            <div
                style={{
                    background: 'radial-gradient(circle, rgba(82,89,94,1) 0%, rgba(46,53,60,1) 100%)',
                }}
            >
                <div className="container d-flex flex-md-row flex-column-reverse justify-content-between pt-4 pb-4">
                    <div className="d-flex flex-column mb-3 align-items-md-start align-items-center justify-content-center">
                        <img
                            src={Logo}
                            alt="QuickTurn"
                            style={{
                                filter: 'drop-shadow(2px 2px 0 rgba(255, 255, 255, 0.5))',
                                height: '100%',
                                minHeight: '35px',
                                maxHeight: '50px',
                                maxWidth: '400px',
                            }}
                            className="mb-3"
                        />
                        <p className="font-size-md " style={{ color: 'white' }}>
                            Quickly and easily design your own parts with our intuitive Part Designer. Add parts to your
                            cart and checkout immediately with a credit or debit card.
                        </p>
                        <Button type="default" className="font-weight-bold" style={{ minWidth: '150px' }}>
                            <UTMQueryPreservingLink to="/quick-turn/design">Try It Now</UTMQueryPreservingLink>
                        </Button>
                    </div>
                    <div className="d-flex align-items-end">
                        <img
                            src={Parts}
                            alt="Parts made by QuickTurn"
                            style={{ maxHeight: '300px', marginTop: '5%', maxWidth: '430px' }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Banner;
